import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { SidekickRun } from 'src/graphql';

export interface AssistantBubbleState {
  text?: string;
  html?: string;
  status: string;
  errorMessage?: string | null;
}

const messageTextSx = { fontSize: 'inherit', lineHeight: 1.5 };

export const AssistantContent = ({
  run,
  bubble,
}: {
  run: SidekickRun;
  bubble?: AssistantBubbleState;
}): ReactNode => {
  if (run.status === 'failed' || bubble?.status === 'failed') {
    const defaultErrorMessage =
      'Sidekick: could not produce a valid reply — try again or check logs.';
    const errorCode = bubble?.errorMessage ?? run.errorMessage;
    const detail = errorCode ? ` (${errorCode})` : '';
    return (
      <Typography variant="body2" color="error" sx={messageTextSx}>
        {`${defaultErrorMessage}${detail}`}
      </Typography>
    );
  }

  if (bubble?.html) {
    return <Box sx={messageTextSx} dangerouslySetInnerHTML={{ __html: bubble.html }} />;
  }

  if (bubble?.text) {
    return (
      <Typography variant="body2" sx={messageTextSx}>
        {bubble.text}
      </Typography>
    );
  }

  const loading = run.status === 'streaming' || bubble?.status === 'streaming';
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {loading ? <CircularProgress size={16} /> : null}
      <Typography variant="body2" color="text.secondary" sx={messageTextSx}>
        {loading ? 'Thinking…' : 'Awaiting response'}
      </Typography>
    </Stack>
  );
};
